<template>
  <div class="dropdown-container w-full relative" ref="dropdown">
    <div class="dropdown-trigger">
      <input
        :value="displayValue"
        @input="onSearch"
        type="text"
        :class="[
  error 
    ? 'border-error bg-red-50 text-red-500 placeholder-red-500' 
    : 'border border-gray-300 text-gray-500 placeholder-gray-400'
]"
        placeholder="Search by Content ID or Title"
        @focus="openDropdown"
      />
    </div>

    <div v-if="isOpen" class="dropdown-list">

      <label
        v-for="item in filteredItems"
        :key="item.id"
        class="dropdown-item justify-start items-center"
      >

        <input
          type="radio"
          :value="item.id"
          v-model="selectedId"
          @change="selectItem(item)"
        />

        <div class="item-content">
          <div class="item-name">
            {{ item.name }}
          </div>

          <div class="item-id">
            ID: {{ item.id }}
          </div>
        </div>
 
      </label>
         
    </div>

  </div>
</template>

<script>
export default {

  name: "ContentDropdown",

  props: {
    items: {
      type: Array,
      default: () => []
    },
     error: {
    type: Boolean,
    default: false
  },
    selected: Object
  },

  data(){
    return{
      search:"",
      selectedId:null,
      isOpen:false
    }
  },

  computed:{

    displayValue(){
      if(this.isOpen) return this.search
      return this.selected ? this.selected.id + ' - ' + this.selected.name : ""
    },

    filteredItems(){

      if(!this.search) return this.items

      const keyword = this.search.toLowerCase()

      return this.items.filter(item =>
        item.name.toLowerCase().includes(keyword) ||
        String(item.id).includes(keyword)
      )

    }

  },

  mounted(){
    document.addEventListener("click", this.handleClickOutside)

    if(this.selected){
      this.selectedId = this.selected.id
    }
  },

  beforeUnmount(){
    document.removeEventListener("click", this.handleClickOutside)
  },

  methods:{

    openDropdown(){
      this.isOpen = true
      this.search = ""
    },

    onSearch(e){
      this.search = e.target.value
      this.isOpen = true
      this.$emit("search", this.search)
    },

    selectItem(item){
      this.selectedId = item.id
      this.search = ""
      this.isOpen = false

      this.$emit("select", item)

    },

   handleClickOutside(event) {
  if (!this.$refs.dropdown) return

  if (!this.$refs.dropdown.contains(event.target)) {
    this.isOpen = false
  }
}

  }

}
</script>

<style scoped>

.dropdown-container{
  width:100%;
  position:relative;
}
.dropdown-trigger {
  position: relative;
}
.dropdown-trigger input{
  width:100%;
  padding:10px 14px;
  font-size: 14px;
  border-radius:8px;
  border:1px solid #ccc;
}

.dropdown-list{
  position:absolute;
  width:100%;
  max-height:246px;
  overflow-y:auto;
  background:white;
  border-radius:10px;
  margin-top: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  z-index:999;
}

.dropdown-item{
  display:flex;
  gap:12px;
  padding:10px;
  margin-bottom: 0px;
  cursor:pointer;
  border-bottom:0px solid #f1f1f1;
}

.dropdown-item:hover{
  background:#f7f7f7;
}

.item-content{
  display:flex;
  flex-direction:column;
}

.item-name{
  font-weight:600;
}
.dropdown-trigger .border-error {
  border:1px solid red;
}
.item-id{
  font-size:13px;
  color:#777;
}

</style>